import Vue from "vue";
import VueRouter from "vue-router";
import paths from "@/router/paths.js";
import functions from "@/router/functions.js";
import modules from "@/store/index.js";
import storage from '@/plugins/storage.plugins.js';
const root = { root: true };

Vue.use(VueRouter);

const router = new VueRouter({
  routes: paths
    .map(path => functions.route(path.path, path.view, path.meta, path.component))
    .concat([{ path: '*', redirect: '/' }]),
});

router.beforeEach((to, from, next) => {
  modules.state.general.routeCount++;
  modules.dispatch('general/pushOrPopRouteOfBreadcrumb', { to }, root);
  if (process.env.VUE_APP_ENV == 'admin') {
    next();
  }
  modules.commit("general/setLoadingOn", true, root);
  if (modules.getters['general/user']) {
    functions.redirect(from, to, next, modules.getters['general/user']);
  } else {
    storage.getUserFromStorage(
      user => { functions.setUser(from, to, next, user); },
      _ => { functions.redirect(from, to, next, null) }
    );
  }
})

export default router;